import React, { useState } from 'react';
import { Divider } from 'antd';
import { RightOutlined } from '@ant-design/icons';

import { translate } from '@portal/services/i18n';

import Certificate from '@portal/assets/svg/onboarding-icons/ic_certificate.svg?react';
import Correct from '@portal/assets/svg/onboarding-icons/ic_correct.svg?react';

import OnboardingUserPhotoModal from '../OnboardingUserPhotoModal/OnboardingUserPhotoModal';
import * as MessageService from '~/services/message';
import { validateOnboardingDocument } from '@portal/utils/validate';

interface IProps {
  setFileSelected: (value: File) => void;
}

const OnboardingSocialContract = ({ setFileSelected }: IProps) => {
  const [modal, setModal] = useState(false);
  const [fileSelectedModal, setFileSelectedModal] = useState<File | null>(null);

  const onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.currentTarget?.files || event.currentTarget.files.length === 0) {
      return;
    }

    const file = event.currentTarget.files[0];

    const isPDF =
      file.type === 'application/pdf' ||
      file.name.toLowerCase().endsWith('.pdf');

    if (!isPDF) {
      return MessageService.error('INVALID_FORMAT');
    }

    if (!validateOnboardingDocument(event)) {
      return;
    }

    setFileSelected(file);
    setFileSelectedModal(file);
  };

  return (
    <>
      <div className="action-display" onClick={() => setModal(true)}>
        <div className="action-display__action">
          <div className="action-display__action__options">
            <Certificate
              width={25}
              height={25}
              className="action-display__action__options__icon"
            />
            <div className="action-display__action__options__container">
              <p className="action-display__action__options__title-document">
                {translate(
                  'PAGES.AUTH.REGISTER.ONBOARD.PF.ONBOARDING_SOCIAL_CONTRACT_DOCUMENT.TITLE'
                )}
              </p>
              <p className="action-display__action__options__text">
                {translate(
                  'PAGES.AUTH.REGISTER.ONBOARD.PF.ONBOARDING_SOCIAL_CONTRACT_DOCUMENT.LABEL'
                )}
              </p>
            </div>
          </div>

          <span>
            {fileSelectedModal ? (
              <Correct width={25} height={25} />
            ) : (
              <RightOutlined
                style={{
                  color: 'black',
                  fontSize: 20,
                }}
              />
            )}
          </span>
        </div>
        <Divider />
      </div>
      {modal ? (
        <OnboardingUserPhotoModal
          onCancel={() => setModal(false)}
          onFileChange={onFileChange}
          visible={modal}
          fileSelected={fileSelectedModal}
          title={translate(
            'PAGES.AUTH.REGISTER.ONBOARD.PF.ONBOARDING_SOCIAL_CONTRACT_DOCUMENT.MODAL_TITLE'
          )}
          accept=".pdf,application/pdf"
          sendType="document"
        />
      ) : null}
    </>
  );
};

export default OnboardingSocialContract;
